export enum GameDayHalf {
    Both,
    First,
    Second
}
